import React from 'react'
import PropTypes from 'prop-types'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay } from 'swiper/modules'
import 'swiper/css'

const AkciiSlyder = ({ slydes, full, onImageClick }) => {
  if(full) return (
    <>
      <div className='mt-[20px] slick-akcii ml-[-10px] w-[calc(100%+20px)]'>
        {slydes.map((elm, k) => {
          if(elm?.image != '') return (
            <div className='px-[10px] font-manrope w-full mb-2' key={k}>
              <div className='mx-auto mb-[22px] rounded-[25px] bg-white'>
                <img 
                  className='w-[100%] object-cover rounded-[25px]' 
                  src={elm?.image} 
                  alt={elm?.title} 
                  width="355" 
                  height="180"
                  style={{objectPosition: `top left`}}
                />
                <div className='p-[15px]'>
                  <div className='flex items-center gap-[7px]'>
                    <div className='text-black text-[18px] font-medium'>{elm?.title}</div>
                    <div className='flex items-center px-[8px] py-[4px] text-[12px] text-white rounded-[15px] bg-[#A6DD2F]'>{elm?.plashka}</div>
                  </div>
                  <div className='mt-[9px] text-[#00000099] text-[14px]'>{elm?.text}</div>
                  {elm?.href != '' &&
                    <a
                      href={elm?.href}
                      className="mt-[10px] w-full p-[5px] h-10 rounded-full text-[16px] font-inter bg-[#5A91FF] text-white flex items-center justify-between gap-2 no-underline"
                    >
                      <div className='w-[30px] h-[30px] rounded-full bg-[#FFFFFF40] flex items-center justify-center'>
                        <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none">
                          <path
                            stroke="#fff"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeMiterlimit={10}
                            d="M16.642 8.333H3.309V15c0 2.5.833 3.333 3.333 3.333h6.667c2.5 0 3.333-.833 3.333-3.333V8.333ZM17.915 5.833v.834c0 .916-.441 1.666-1.666 1.666h-12.5c-1.275 0-1.667-.75-1.667-1.666v-.834c0-.916.392-1.666 1.667-1.666h12.5c1.225 0 1.666.75 1.666 1.666ZM9.699 4.167h-4.6a.78.78 0 0 1 .025-1.084L6.307 1.9a.8.8 0 0 1 1.125 0L9.7 4.167ZM14.891 4.167h-4.6L12.558 1.9a.8.8 0 0 1 1.125 0l1.183 1.183c.3.3.308.775.025 1.084Z"
                          />
                          <path
                            stroke="#fff"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeMiterlimit={10}
                            d="M7.451 8.333v4.284a.835.835 0 0 0 1.292.7l.783-.517a.833.833 0 0 1 .917 0l.742.5a.83.83 0 0 0 1.291-.692V8.333H7.451Z"
                          />
                        </svg>
                      </div>
                      <div>Подробнее об акции</div>
                      <div className='w-[30px] h-[30px]'></div>
                    </a>
                  }
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </>
  )

  return (
    <div className='mt-[20px] slick-akcii w-[calc(100%+10px)] lg:w-full overflow-x-hidden storis_slick'>
      <div className='w-[calc(100%+60px)]'>
        <Swiper
          modules={[Autoplay]}
          spaceBetween={0}
          slidesPerView={5}
          draggable
          loop
          autoplay={{ delay: 4000, disableOnInteraction: false }}
          breakpoints={{
            0: {
              slidesPerView: 3
            },
            992: {
              slidesPerView: 5
            }
          }}
        >
          {slydes.map((elm, k) => {
            if(elm?.vertical != '') return (
              <SwiperSlide key={k}>
                <div 
                  className={`px-[2px] ${
                      elm?.storys && elm.storys.length > 0 ? 'cursor-pointer' : ''
                    }`}
                  onClick={() => {
                    if (onImageClick && elm?.storys?.length > 0) {
                      onImageClick(elm.storys, k)
                    }
                  }}
                >
                  <img 
                    className={`w-full h-auto mb-[22px] object-cover rounded-[15px] bg-white`}
                    src={elm?.vertical} 
                    alt={elm?.title} 
                    width="142" 
                    height="213"
                    style={{objectPosition: `top left`}}
                  />
                </div>
              </SwiperSlide>
            )
          })}
        </Swiper>
      </div>
    </div>
  )
}

AkciiSlyder.propTypes = {
  slydes: PropTypes.array,
  full: PropTypes.bool,
  onImageClick: PropTypes.func
}

AkciiSlyder.defaultProps = {
  slydes: [],
  full: false,
  onImageClick: null
}

export default AkciiSlyder
